import { createFeatureSelector, createSelector } from '@ngrx/store';

import { MarketState } from './market.state';

const selectMarketState = createFeatureSelector<MarketState>('market');

export const isMarketModuleInitialized = createSelector(selectMarketState, (state: MarketState) => state?.initialized);

export const getMarketLanguages = createSelector(selectMarketState, (state: MarketState) => state?.marketLanguages);

export const getUrlTranslations = createSelector(selectMarketState, (state: MarketState) => state?.urlTranslations);
